import { messages } from './StepperTwoFaWizard.messages';

export const steps = [{ text: messages.step1 }, { text: messages.step2 }, { text: messages.step3 }];
